import React, { useEffect, useMemo, useState } from "react";
import { Grid as MuiGrid } from "@mui/material";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { Input } from "@progress/kendo-react-inputs";
import { Button } from "@progress/kendo-react-buttons";
import { useDispatch, useSelector } from "react-redux";

import {
     participantGetAreasRequest,
     retailSalesSaveDealersRequest,
} from "../../../../../_redux/_actions";
import { retailSalesConstants } from "../../../../../_redux/_constants/retailSales.constants";

/**
 * Creates a dealer we do not hold yet, already flagged as retail - for a winner whose dealer is not
 * on Equipe. Dealers we already have are switched on straight from the table instead.
 */
export default function AddRetailDealerForm(props) {
     const { onSaved } = props;

     const actionDispatch = useDispatch();

     const areas = useSelector(
          (state) => state?.participantsManagement?.areaList,
     );

     const [dealerCode, setDealerCode] = useState("");
     const [dealerName, setDealerName] = useState("");
     const [area, setArea] = useState(null);
     const [isRetail, setIsRetail] = useState(true);

     useEffect(() => {
          actionDispatch(
               participantGetAreasRequest({
                    applicationId:
                         retailSalesConstants.RETAIL_SALES_APPLICATION_EQUIPE_ID,
               }),
          );
     }, [actionDispatch]);

     const areaOptions = useMemo(
          () =>
               (Array.isArray(areas) ? areas : []).map((item) => ({
                    id: item.id,
                    name: item.area || item.name,
               })),
          [areas],
     );

     // A retail dealer needs an area; a plain one does not.
     const canSave =
          dealerCode.trim() && dealerName.trim() && (!isRetail || area);

     const save = () => {
          actionDispatch(
               retailSalesSaveDealersRequest({
                    dealers: [
                         {
                              dealerCode: dealerCode.trim(),
                              name: dealerName.trim(),
                              isRetailCarSalesDealer: isRetail,
                              retailAreaId: isRetail ? area.id : undefined,
                         },
                    ],
               }),
          );

          if (onSaved) {
               onSaved();
          }
     };

     return (
          <MuiGrid container spacing={2}>
               <MuiGrid item xs={12} lg={6}>
                    <Input
                         style={{ width: "100%" }}
                         label="Dealer code"
                         value={dealerCode}
                         onChange={(event) => setDealerCode(event.value)}
                    />
               </MuiGrid>
               <MuiGrid item xs={12} lg={6}>
                    <Input
                         style={{ width: "100%" }}
                         label="Dealer name"
                         value={dealerName}
                         onChange={(event) => setDealerName(event.value)}
                    />
               </MuiGrid>
               <MuiGrid
                    item
                    xs={12}
                    lg={6}
                    sx={{ display: "flex", alignItems: "center" }}
               >
                    <label
                         style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                         }}
                    >
                         <input
                              type="checkbox"
                              className="k-checkbox k-checkbox-md"
                              checked={isRetail}
                              onChange={(event) =>
                                   setIsRetail(event.target.checked)
                              }
                         />
                         Retail sales dealer
                    </label>
               </MuiGrid>
               <MuiGrid item xs={12} lg={6}>
                    <DropDownList
                         // 38px matches the height of the text inputs above.
                         style={{ width: "100%", height: "38px" }}
                         label="Retail area"
                         data={areaOptions}
                         textField="name"
                         dataItemKey="id"
                         disabled={!isRetail}
                         value={area}
                         onChange={(event) => setArea(event.value)}
                    />
               </MuiGrid>
               <MuiGrid item xs={12}>
                    <Button
                         type="button"
                         themeColor="primary"
                         disabled={!canSave}
                         onClick={save}
                    >
                         Save
                    </Button>
               </MuiGrid>
          </MuiGrid>
     );
}
